<template>
    <v-card color="white" v-if="(GETTERS_SAMPLETYPES !== null)">
      <v-container>
        <v-row>
          <v-col cols="12">
            <b class="help-step" style="cursor:help;" @click="show_help($t('new-proposal.step-4.sample_description.text'), $t('new-proposal.step-4.sample_description.help'))">
              {{$t('new-proposal.step-4.sample_description.text')}}
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="cursor:help;"
                  >
                    <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('new-proposal.step-4.sample_description.help') }}</span>
              </v-tooltip>
            </b>
            <v-textarea
              v-model="currentSample_description"
              outlined
              :error="errorSample_description"
              :rules="[rules.required]"
              @input="currentSample_description.length !== 0 ? errorSample_description = false : errorSample_description = true"
              type="text"
              counter="120"
              maxLength="128"
              rows="1"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="6">
            <v-row>
              <v-col cols="12">
                <b class="help-step" style="cursor:help;" @click="show_help($t('new-proposal.step-4.sample_type.text'), $t('new-proposal.step-4.sample_type.help'))">
                  {{$t('new-proposal.step-4.sample_type.text')}}
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="cursor:help;"
                      >
                        <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('new-proposal.step-4.sample_type.help') }}</span>
                  </v-tooltip>
                </b>
                <v-select
                  :items="GETTERS_SAMPLETYPES"
                  item-text="name"
                  item-value="id"
                  outlined
                  v-model="currentSample_type"
                  @input="currentSample_type.length !== 0 ? errorSample_type = false : errorSample_type = true"
                  :rules="[rules.required]"
                  :error="errorSample_type"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="7" class="pa-0 pt-3" style="text-align: end;">
                <b class="help-step" style="cursor:help;" @click="show_help($t('new-proposal.step-4.sample_count.text'), $t('new-proposal.step-4.sample_count.help'))">
                  {{$t('new-proposal.step-4.sample_count.text')}}
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="cursor:help;"
                      >
                        <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('new-proposal.step-4.sample_count.help') }}</span>
                  </v-tooltip>
                </b>
              </v-col>
              <v-col cols="5" class="pa-0 pl-3 pr-3">
                <v-text-field
                  v-model="currentSample_count"
                  outlined
                  type="number"
                  @input="currentSample_count && currentSample_count>0 ? errorSample_count = false : errorSample_count = true"
                  :error="errorSample_count"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="7" class="pa-0 pt-3" style="text-align: end;">
                <b class="help-step" style="cursor:help;" @click="show_help($t('new-proposal.step-4.sample_avarage_size.text'), $t('new-proposal.step-4.sample_avarage_size.help'))">
                  {{$t('new-proposal.step-4.sample_avarage_size.text')}}
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="cursor:help;"
                      >
                        <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('new-proposal.step-4.sample_avarage_size.help') }}</span>
                  </v-tooltip>
                </b>
              </v-col>
              <v-col cols="5" class="pa-0 pl-3 pr-3">
                <v-text-field
                  v-model="currentSample_avarage_size"
                  outlined
                  type="number"
                  @input="(currentSample_avarage_size || currentSample_volume || currentSample_surface_area || currentSample_mass) ? errorSample_sizes = false : errorSample_sizes = true"
                  :error="errorSample_sizes"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="7" class="pa-0 pt-3" style="text-align: end;">
                <b class="help-step" style="cursor:help;" @click="show_help($t('new-proposal.step-4.sample_volume.text'), $t('new-proposal.step-4.sample_volume.help'))">
                  {{$t('new-proposal.step-4.sample_volume.text')}} (мм<sup>3</sup>)
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="cursor:help;"
                      >
                        <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('new-proposal.step-4.sample_volume.help') }}</span>
                  </v-tooltip>
                </b>
              </v-col>
              <v-col cols="5" class="pa-0 pl-3 pr-3">
                <v-text-field
                  v-model="currentSample_volume"
                  outlined
                  type="number"
                  @input="(currentSample_avarage_size || currentSample_volume || currentSample_surface_area || currentSample_mass) ? errorSample_sizes = false : errorSample_sizes = true"
                  :error="errorSample_sizes"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="7" class="pa-0 pt-3" style="text-align: end;">
                <b class="help-step" style="cursor:help;" @click="show_help($t('new-proposal.step-4.sample_surface_area.text'), $t('new-proposal.step-4.sample_surface_area.help'))">
                  {{$t('new-proposal.step-4.sample_surface_area.text')}} (мм<sup>2</sup>)
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="cursor:help;"
                      >
                        <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('new-proposal.step-4.sample_surface_area.help') }}</span>
                  </v-tooltip>
                </b>
              </v-col>
              <v-col cols="5" class="pa-0 pl-3 pr-3">
                <v-text-field
                  v-model="currentSample_surface_area"
                  outlined
                  type="number"
                  @input="(currentSample_avarage_size || currentSample_volume || currentSample_surface_area || currentSample_mass) ? errorSample_sizes = false : errorSample_sizes = true"
                  :error="errorSample_sizes"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="7" class="pa-0 pt-3" style="text-align: end;">
                <b class="help-step" style="cursor:help;" @click="show_help($t('new-proposal.step-4.sample_mass.text'), $t('new-proposal.step-4.sample_mass.help'))">
                  {{$t('new-proposal.step-4.sample_mass.text')}}
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="cursor:help;"
                      >
                        <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('new-proposal.step-4.sample_mass.help') }}</span>
                  </v-tooltip>
                </b>
              </v-col>
              <v-col cols="5" class="pa-0 pl-3 pr-3">
                <v-text-field
                  v-model="currentSample_mass"
                  outlined
                  type="number"
                  @input="(currentSample_avarage_size || currentSample_volume || currentSample_surface_area || currentSample_mass) ? errorSample_sizes = false : errorSample_sizes = true"
                  :error="errorSample_sizes"
                ></v-text-field>
              </v-col>
            </v-row>

          </v-col>
          <v-col cols="12" lg="6" class="pl-8 pt-8">
            <b class="help-step" style="cursor:help;" @click="show_help($t('toxicityLabel.text'), $t('toxicityLabel.help'))">
              {{$t('toxicityLabel.text')}}
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="cursor:help;"
                  >
                    <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('toxicityLabel.help') }}</span>
              </v-tooltip>
            </b>
            <v-switch
              v-model="toxicity"
              
              :color="$mainColor"
            ></v-switch>

            <b class="help-step" style="cursor:help;" @click="show_help($t('biologicalDanger.text'), $t('biologicalDanger.help'))">
              {{$t('biologicalDanger.text')}}
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="cursor:help;"
                  >
                    <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('biologicalDanger.help') }}</span>
              </v-tooltip>
            </b>
            <v-switch
              v-model="biologicalHazard"
              
              :color="$mainColor"
            ></v-switch>

            <b class="help-step" style="cursor:help;" @click="show_help($t('otherDanger.text'), $t('otherDanger.help'))">
              {{$t('otherDanger.text')}}
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    style="cursor:help;"
                  >
                    <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('otherDanger.help') }}</span>
              </v-tooltip>
            </b>
            <v-switch
              v-model="otherHazards"
              :color="$mainColor"
              
            ></v-switch>
            <v-textarea
              v-if="otherHazards"
              :disabled="!otherHazards"
              v-model="otherHazardsDesc"
              no-resize
              outlined
              type="text"
              counter="400"
              maxLength="400"
            ></v-textarea>
          </v-col>
        </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: 'SampleData',
  props: [
    'is_toxic', 'is_biohazard', 'is_different_dangerous',
    'other_dangers',
    'sample_description',
    'sample_type_id',
    'sample_avarage_size',
    'sample_volume',
    'sample_surface_area',
    'sample_mass',
    'sample_count',
  ],

  computed: {
    ...mapGetters([
      'GETTERS_SAMPLETYPES',
      'GETTERS_NEW_PROPOSAL_STEPPER_NEED_CHECK',
    ]),
  },

  data() {
    return {
      error: false,
      toxicity: this.is_toxic,
      biologicalHazard: this.is_biohazard,
      otherHazards: this.is_different_dangerous,
      otherHazardsDesc: this.other_dangers,
      currentSample_count: this.sample_count,
      currentSample_description: this.sample_description,
      currentSample_avarage_size: this.sample_avarage_size,
      currentSample_type: this.sample_type_id,
      currentSample_volume: this.sample_volume,
      currentSample_surface_area: this.sample_surface_area,
      currentSample_mass: this.sample_mass,
      errorSample_description: false,
      errorSample_type: false,
      errorSample_count: false,
      errorSample_sizes: false,
      types: [],
      rules: {
        required: (value) => (value === null || value.length === 0) ? this.$t('required') : true,
      },
    };
  },

  watch: {
    'GETTERS_NEW_PROPOSAL_STEPPER_NEED_CHECK.step4'(val){
      if(val){
        var status = this.validateInputs()
        this.NEW_PROPOSAL_UPDATE_STEPPER_CHECK_STATUS({name: 'step4', value: status})
        this.NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK({name: 'step4', value: false})
      }
    },
    
    async toxicity(val) {
      this.UPDATE_QUIZE({is_toxic: val});
    },
    async biologicalHazard(val) {
      this.UPDATE_QUIZE({is_biohazard: val});
    },
    async otherHazards(val) {
      this.UPDATE_QUIZE({is_different_dangerous: val});
    },
    async otherHazardsDesc(val) {
      this.UPDATE_QUIZE({other_dangers: val});
    },
    async currentSample_description(val) {
      this.UPDATE_QUIZE({sample_description: val});
    },
    async currentSample_count(val) {
      this.UPDATE_QUIZE({sample_count: parseInt(val)});
    },
    async currentSample_avarage_size(val) {
      this.UPDATE_QUIZE({sample_avarage_size: parseFloat(val)});
    },
    async currentSample_type(val) {
      this.UPDATE_QUIZE({sample_type_id: val});
    },
    async currentSample_volume(val) {
      this.UPDATE_QUIZE({sample_volume: parseFloat(val)});
    },
    async currentSample_surface_area(val) {
      this.UPDATE_QUIZE({sample_surface_area: parseFloat(val)});
    },
    async currentSample_mass(val) {
      this.UPDATE_QUIZE({sample_mass: parseFloat(val)});
    },

  },

  methods: {
    ...mapMutations([
      'UPDATE_QUIZE',
      'UPDATE_HELPER_DIALOG',
      'NEW_PROPOSAL_UPDATE_STEPPER_CHECK_STATUS',
      'NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK',
    ]),

    show_help(header = '', text = ''){
      this.UPDATE_HELPER_DIALOG({
        'show' : true,
        'helper_data': {
          'header': header,
          'text': text,
        }
      })
    },

    validateInputs() {
      var status = true

      if (this.currentSample_description === null || this.currentSample_description.length === 0){
        this.errorSample_description = true
        status = false
      }

      if (this.currentSample_type === null || this.currentSample_type.length === 0){
        this.errorSample_type = true
        status = false
      }

      if (this.currentSample_count === null || this.currentSample_count <= 0){
        this.errorSample_count = true
        status = false
      }

      if ((this.currentSample_avarage_size === null || this.currentSample_avarage_size.length === 0) 
        && (this.currentSample_volume === null || this.currentSample_volume.length === 0) 
        && (this.currentSample_surface_area === null || this.currentSample_surface_area.length === 0) 
        && (this.currentSample_mass === null || this.currentSample_mass.length === 0) 
      ){
        this.errorSample_sizes = true
        status = false
      }

      return status
    },
  },
};
</script>
